var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42254 12.0209C1.42254 12.0209 1.43114 4.11461 1.43341 2.02094L0.766746 2.02022L0.768196 0.686884L4.10153 0.690509L4.10225 0.0238429L8.10225 0.028193L8.10152 0.694859L11.4349 0.698484L11.4334 2.03182L10.7667 2.03109L10.7559 12.0311C8.77583 12.0289 1.42254 12.0209 1.42254 12.0209ZM4.0921 9.35717L5.42543 9.35862L5.43196 3.35862L4.09863 3.35717L4.0921 9.35717ZM6.75877 9.36007L8.0921 9.36152L8.09862 3.36152L6.76529 3.36007L6.75877 9.36007Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.505da78bdb848b30a8cb8563144482e1.svg";
export { ForwardRef as ReactComponent };